import React, { useState } from 'react';
import { WebhookEventPayload } from './data/webhookEvents';
import { JsonFormatter } from './JsonFormatter';
import { Card, Button } from 'antd';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { WebhookType } from '@/types/TReseller';

interface WebhookEventCardProps {
	event: WebhookEventPayload;
	payloadType: WebhookType;
}

export const WebhookEventCard: React.FC<WebhookEventCardProps> = ({ event, payloadType }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<Card
			style={{
				backgroundColor: '#121826',
				borderColor: '#1E293B',
				borderRadius: '12px',
				overflow: 'hidden',
			}}
			styles={{
				body: {
					padding: 0,
				},
				header: {
					backgroundColor: '#1A1F2C',
					borderBottom: '1px solid #2D3748',
					padding: '16px 24px',
					borderTopLeftRadius: '12px',
					borderTopRightRadius: '12px',
				},
			}}
			title={
				<div className="text-white">
					<div className="text-xl font-bold">{event.name}</div>
					<div className="text-sm text-gray-300 mt-1">{event.description}</div>
				</div>
			}
			extra={
				<Button
					type="text"
					icon={isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
					onClick={() => setIsExpanded(!isExpanded)}
					className="text-gray-300 hover:!text-white"
				/>
			}
		>
			{isExpanded && (
				<div className="px-6 py-4">
					<JsonFormatter
						data={event[payloadType === WebhookType.API ? 'apiPayload' : 'slackPayload']}
					/>
				</div>
			)}
		</Card>
	);
};
